module.exports = __webpack_public_path__ + "static/img/rank_74.deeca3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_74.png
// module id = Macw
// module chunks = 1